import {
  Button,
  Divider,
  Form,
  Input,
  InputNumber,
  Drawer,
  notification,
  Space,
  Tooltip,
} from "antd";
import { useEffect, useState, useRef } from "react";
import TdsTcsServices from "../../../Services/TdsTcsServices";
import { NotificationType } from "../../../Common/Routing/PageRoute";
import { useClient } from "../../../Context/ClientContext";
import { CloseOutlined } from "@ant-design/icons";
import { useHotkey } from "../../../Context/HotKeyContext";
import EntryLevelKeys from "../../../Common/EntryLevelKeys";

interface IPropsTcs {
  open: boolean;
  setOpen: (value: boolean) => void;
  setTrigger: React.Dispatch<React.SetStateAction<boolean>>;
  editData?: any;
}

const AddTcsTaxRate = (props: IPropsTcs) => {
  const { showKeys } = useHotkey();
  console.log("props: ", props.editData?.id);
  const autoCompleteRef = useRef<any>(null);
  const { currentClient } = useClient();
  const [form] = Form.useForm();
  const [saveButtonLoading, setSaveButtonLoading] = useState<boolean>(false);
  const [api, contextHolder] = notification.useNotification();

  const openNotification = (type: NotificationType, message: string) => {
    api[type]({
      message: "",
      description: message,
      duration: 2,
      closeIcon: false,
      style: {
        width: 350,
      },
    });
  };
  useEffect(() => {
    const timer = setTimeout(() => {
      if (autoCompleteRef.current) {
        autoCompleteRef.current.focus();
      }
    }, 100); // Adjust delay if needed

    return () => clearTimeout(timer);
  }, []); // Ensures autofocus after initial render
  useEffect(() => {
    if (props.editData?.id) {
      form.setFieldsValue({
        section: props.editData?.section,
        natureOfCollection: props.editData?.natureOfCollection,
        rate: props.editData?.rate,
        // effectiveDate: dayjs(
        //   dayjs(props.editData?.effectiveDate).format("DD/MM/YYYY"),
        //   "DD/MM/YYYY"
        // ),
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.editData?.id]);

  const saveTCS = () => {
    form.validateFields().then(async (value) => {
      try {
        setSaveButtonLoading(true);
        const postData = {
          ...value,
          // effectiveDate: dayjs(
          //   dayjs(value?.effectiveDate).format("DD/MM/YYYY"),
          //   "DD/MM/YYYY"
          // ),
        };

        const res = await TdsTcsServices.postTCS(
          currentClient?.id!,
          postData,
          props.editData?.id
        );
        console.log("result", res);

        if (res.status) {
          // debugger;
          openNotification(
            "success",
            `${props.editData?.id ? "updated TCS rate." : "added TCS rate."}`
          );
          setSaveButtonLoading(false);
          props.setOpen(false);
          props.setTrigger((x: boolean) => !x);
        } else {
          setSaveButtonLoading(false);
          console.error("error", res?.message);
          res?.message && openNotification("error", res.message);
        }
      } catch (err: any) {
        // openNotification("error", err);
        console.error("error", err);
        err && openNotification("error", err);
        setSaveButtonLoading(false);
      }
    });
  };

  EntryLevelKeys({
    save: () => saveTCS(),
    cancel: () => props.setOpen(false),
  });

  return (
    <>
      <Drawer
        maskClosable={false}
        title={props.editData?.id ? "Update TCS Rate" : "Add TCS Rate"}
        open={props.open}
        width={500}
        // centered
        // onOk={handleOk}
        onClose={() => props.setOpen(false)}
        closable={false}
        extra={
          <Space>
            <CloseOutlined onClick={() => props.setOpen(false)} />
          </Space>
        }
        footer={
          <div style={{ textAlign: "right" }}>
            <Tooltip
              title={<p>ALT+C</p>}
              placement="bottomLeft"
              open={showKeys}
            >
              <Button
                onClick={() => {
                  form.resetFields();
                  props.setOpen(false);
                }}
              >
                Cancel
              </Button>
            </Tooltip>
            <Tooltip
              title={<p>ALT+S</p>}
              placement="bottomLeft"
              open={showKeys}
            >
              <Button
                type="primary"
                onClick={() => saveTCS()}
                style={{ width: "80px" }}
                loading={saveButtonLoading}
                className="modelSaveButtonMargin"
              >
                {props.editData?.id ? "Update" : "Save"}
              </Button>
            </Tooltip>
          </div>
        }
      >
        {/* <Spin */}
        {/* // indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} */}
        {/* // spinning={loading} */}
        {/* > */}
        <Form
          form={form}
          // layout="vertical"
          labelWrap={true}
          autoComplete="off"
          colon={false}
          labelAlign="left"
          name="tscDetail"
          requiredMark={true}
          layout="vertical"
          // initialValues={intialValue}
        >
          <Form.Item
            // className="inputBoxMb8"
            name="section"
            label="Section"
            rules={[{ required: true, message: "Section is required" }]}
            className="input-item"
          >
            <Input ref={autoCompleteRef} />
          </Form.Item>

          <Form.Item
            name="natureOfCollection"
            label="Nature Of Collection"
            rules={[
              { required: true, message: "Nature of collection is required" },
            ]}
            // className="inputBoxMb8"
            className="input-item"
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Rate (%)"
            name="rate"
            rules={[
              {
                required: true,
                message: "Rate is required",
              },
            ]}
            className="input-item"
          >
            <InputNumber
              min={0}
              max={100}
              style={{ width: "100%" }}
              controls={false}
            />
          </Form.Item>

          {/* <Form.Item
            className="mb-14"
            label="EffectiveDate"
            name="effectiveDate"
          >
            <DatePicker format="DD/MM/YYYY" style={{ width: "100%" }} />
          </Form.Item> */}
        </Form>
      </Drawer>
      {contextHolder}
    </>
  );
};

export default AddTcsTaxRate;
